<template>
    <div class="bun-selector configurator-element">
        <div class="section-header">
            <span class="step-label">
                <span class="number">2</span>
                <strong>- {{ $t('bunselector.title') }} -</strong><br>
            </span>
            <InputField name="recipeName" v-on:invalid="nameIsInvalid" v-on:valid="nameIsValid" :placeholder="$t('forms.bunNaming')" icon="edit" required :pattern="namePattern" :submitted="submitted" :limit="25"></InputField>
            <div v-if="!nameValidState" class="name-valid-state">{{ $t('forms.bunNaming.error') }}</div>
        </div>
        <div>
            <h3>{{ $t('bunselector.buntitle') }}</h3>
            <ul>
                <li v-for="bun in buns" :key="bun.key">
                    <button class="btn-image" v-on:click="selectBun(bun)" :class="{ active: isActive(bun.id) }">
                        <ImageLoader :name="bun.name" :src="bun.image"></ImageLoader>
                        <span class="bun-name">{{ bun.name }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import loaderMixin from '@/mixins/loaderMixin'
  import ImageLoader from './ImageLoader'
  import InputField from './InputField'

  export default {
    name: 'BunSelector',
    components: { InputField, ImageLoader },
    mixins: [loaderMixin],
    data: function () {
      return {
        /**
         * recipeName validation pattern
         * min length 3
         * and does not contain any special chars
         */
        namePattern: '^[^<>:?!\'"`$]{3,}$',
        nameValidState: true
      }
    },
    computed: {
      submitted: function () {
        return this.$store.state.submissionStatus
      },
      buns: function () {
        return this.$store.state.buns
      },
      options: function () {
        return this.$store.state.options
      },
      curBunId: function () {
        return this.curRecipe['bun'].id
      }
    },
    created () {
      // sync recipe input model with recipe data
      this.$store.watch(
        (state) => {
          return state.fieldValues.recipeName
        },
        (value) => {
          this.$store.commit('setRecipeName', value)
        }
      )
    },
    mounted () {
      //set first bun as defult
      // this.selectBun(this.$store.state.buns[0]);
    },
    methods: {
      /**
       * commit bun recipe
       * @param bun
       */
      selectBun: function (bun) {
        this.$store.commit('selectBun', bun)

        this.loadRecipe(bun.defaults)
      },

      /**
       * is button active
       * @param id
       * @returns {boolean}
       */
      isActive: function (id) {
        return (id === this.curBunId)
      },

      nameIsValid: function () {
        this.$store.commit('showModalCover', false)
        this.nameValidState = true
      },

      nameIsInvalid: function () {
        if (this.submitted) {
          this.$store.commit('showModalCover', true)
          this.nameValidState = false
        }
      }
    }
  }
</script>
